(() => {
  function setupSearch() {
    document.querySelectorAll('.ak-search[data-predictive-url]').forEach(form => {
      if (form.dataset.searchReady) return;
      form.dataset.searchReady = 'true';
      const input = form.querySelector('input[name="q"]');
      const panel = form.querySelector('.ak-search-panel');
      if (!input || !panel) return;
      let timer, controller, version = 0;
      const close = () => { clearTimeout(timer); controller?.abort(); version += 1; panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };
      const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
      const safeUrl = value => {
        try { const url = new URL(value, location.origin); return url.origin === location.origin ? url.pathname + url.search : null; }
        catch { return null; }
      };
      const heading = title => { const h = document.createElement('h3'); h.textContent = title; panel.append(h); };
      const addLink = (resource, kind) => {
        const url = safeUrl(resource.url);
        if (!url) return;
        const link = document.createElement('a'); link.href = url;
        if (kind === 'product' && resource.image) {
          const image = document.createElement('img'); image.src = resource.image; image.alt = ''; image.width = 45; image.height = 45; link.append(image);
        }
        const copy = document.createElement('span'); copy.className = 'ak-suggest-copy';
        const title = document.createElement('span'); title.textContent = resource.title; copy.append(title);
        if (kind === 'product' && Number.isFinite(Number(resource.price))) {
          const price = document.createElement('strong');
          price.textContent = new Intl.NumberFormat('hu-HU', { style: 'currency', currency: form.dataset.currency || 'HUF', maximumFractionDigits: 0 }).format(Number(resource.price));
          copy.append(price);
        }
        link.append(copy); panel.append(link);
      };
      const render = (results, query) => {
        panel.replaceChildren();
        const closeButton = document.createElement('button'); closeButton.type = 'button'; closeButton.className = 'ak-search-panel-close'; closeButton.textContent = '×'; closeButton.setAttribute('aria-label', 'Keresési javaslatok bezárása'); closeButton.addEventListener('click', () => { close(); input.focus(); }); panel.append(closeButton);
        const collections = results.collections || []; const products = results.products || [];
        if (collections.length) { heading('Karakterek és válogatások'); collections.forEach(item => addLink(item, 'collection')); }
        if (products.length) { heading('Termékek'); products.forEach(item => addLink(item, 'product')); }
        if (!collections.length && !products.length) { const message = document.createElement('p'); message.className = 'ak-search-status'; message.textContent = 'Nincs közvetlen javaslat. Próbálj rövidebb nevet, vagy nézd meg az összes találatot.'; panel.append(message); }
        const all = document.createElement('a'); const url = new URL(form.action); url.search = new URLSearchParams({ q: query, type: 'product', 'options[prefix]': 'last' }); all.href = url.pathname + url.search; all.className = 'ak-search-all'; all.textContent = 'Összes találat megtekintése →'; panel.append(all); open();
      };
      input.addEventListener('input', () => {
        close();
        const query = input.value.trim();
        const requestVersion = version;
        if (query.length < 2) { close(); return; }
        timer = setTimeout(async () => {
          controller = new AbortController();
          try {
            const url = new URL(form.dataset.predictiveUrl + '.json', location.origin);
            url.search = new URLSearchParams({ q: query, 'resources[type]': 'product,collection', 'resources[limit]': '4', 'resources[limit_scope]': 'each', 'resources[options][unavailable_products]': 'last' });
            const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Predictive search unavailable');
            const result = await response.json();
            if (requestVersion === version && input.value.trim() === query && document.activeElement === input) render(result.resources?.results || {}, query);
          } catch (error) { if (error.name !== 'AbortError') close(); }
        }, 240);
      });
      form.addEventListener('keydown', event => {
        if (event.key === 'Escape') { close(); input.focus(); return; }
        if (panel.hidden || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        const links = [...panel.querySelectorAll('a')]; if (!links.length) return;
        event.preventDefault(); const current = links.indexOf(document.activeElement);
        links[(current + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
      });
      form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget)) close(); });
      form.addEventListener('submit', close);
      document.addEventListener('click', event => { if (!form.contains(event.target)) close(); });
    });
  }
  setupSearch();
  document.addEventListener('shopify:section:load', setupSearch);

  let cartTimer;
  document.addEventListener('cart:update', async event => {
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.ak-cart b').forEach(badge => { badge.textContent = cart.item_count; badge.setAttribute('aria-label', `${cart.item_count} termék a kosárban`); });
      if (event.detail?.data?.source !== 'product-form-component' || event.detail?.data?.didError) return;
      let feedback = document.querySelector('.ak-cart-feedback');
      if (!feedback) { feedback = document.createElement('div'); feedback.className = 'ak-cart-feedback'; feedback.setAttribute('role', 'status'); feedback.append(document.createTextNode('A termék a kosaradba került.')); const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'Kosár megtekintése →'; feedback.append(link); document.body.append(feedback); }
      feedback.hidden = false; clearTimeout(cartTimer); cartTimer = setTimeout(() => { feedback.hidden = true; }, 9000);
    } catch { /* Native commerce feedback remains available if the badge refresh fails. */ }
  });
})();
